<fieldset>
  <div class="column-100">
      <gmt-input label="Datum potvrzení správní žaloby" required="true">
        <input type="text" pick-a-date [(ngModel)]="data.expropriationAdministrativeAppealAcceptedDate" [maxToday]="true"/>
      </gmt-input>
  </div>
</fieldset>
